import React, { useEffect, useRef, useState } from 'react';
import { flushSync } from 'react-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ButtonIcon } from '@vds/button-icons';

import {
  Block,
  ContainerWrapper,
  Flex,
  MOBILE_BREAKPOINT,
} from '../../../components/common/StyledComponent/CommonStyledComponent';
import {
  AskAICtaButtonRow,
  AskAICtaCard,
  AskAICtaPrimaryButton,
  AskAICtaSecondaryButton,
  HeaderButton,
  ModalButtonRow,
  ModalCard,
  ModalCloseButton,
  ModalOverlay,
  SegmentedToggle,
  ToggleContentTransition,
  ToggleSegment,
  ToggleSlider,
  ToggleWrapper,
} from '../AskAIPageStyles';
import AskAIFooter from './AskAIFooter';
import AskAIGeneratingResponse from './AskAIGeneratingResponse';
import AskAIInitialResponse from './AskAIInitialResponse';
import AskAIPageBanner from './AskAIPageBanner/AskAIPageBanner';
import AskAISuggestionResponse2 from './AskAISuggestionResponse2';
import AskAITopRecommendationSection from './AskAITopRecommendationSection';
import InlineSearch from './InlineSearch/InlineSearch';
import NewSearchModal from './NewSearchModal';
import LangSwitchModal from './LangSwitchModal';
import { Icon } from '@vds/icons';
import { decodeHTML, parseSSEChunk } from '../../../utility/utils.js';
import { getInfoHubHtml, postVzgptChat } from '../../../utility/common';
import {updateRegisterTriggeredFrom} from "../../../store/aem.js";
import store from '../../../store/store.js';
import SearchResultsComponent from '../../AI-Search/ClassicSearch/Search-Results/searchResults.jsx';
import {contentClick, pageLoadCompleted, pageLoadStarted, viewSearchResults} from "../../../common/Analytics/GAWrapper.jsx";
import { Helmet } from 'react-helmet';
import DOMPurify from 'dompurify';

const INLINE_SEARCH_REVEAL_DELAY = 500;
const SECTION_SCROLL_DURATION = 700;
const SCROLL_UP_STICKY_Z_INDEX = 999;
const ACTION_BAR_TRANSITION_MS = 360;
const ACTION_BAR_OPACITY_TRANSITION_MS = 90;
const ACTION_BAR_EASING = 'ease-in';
const TOGGLE_EXIT_DURATION = 360;

const easeInOutCubic = (progress) => {
  if (progress < 0.5) {
    return 4 * progress * progress * progress;
  }

  return 1 - Math.pow(-2 * progress + 2, 3) / 2;
};

const AskAIPage = () => {
  const dispatch = useDispatch();
  const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
  const [isAskAI, setIsAskAI] = useState(true);
  const [renderedIsAskAI, setRenderedIsAskAI] = useState(true);
  const [toggleContentPhase, setToggleContentPhase] = useState('entered');
  const [showAiResponse, setShowAiResponse] = useState(false);
  const [initialShowFeedbackPanel, setInitialShowFeedbackPanel] =
    useState(false);
  const [initialIsFeedbackClosing, setInitialIsFeedbackClosing] =
    useState(false);
  const [initialSelectedThumb, setInitialSelectedThumb] = useState(null);
  const [suggestionShowFeedbackPanel, setSuggestionShowFeedbackPanel] =
    useState(false);
  const [suggestionIsFeedbackClosing, setSuggestionIsFeedbackClosing] =
    useState(false);
  const [suggestionSelectedThumb, setSuggestionSelectedThumb] = useState(null);
  const [selectedSuggestion, setSelectedSuggestion] = useState('');
  const [isSuggestionLoading, setIsSuggestionLoading] = useState(false);
  const [showSuggestionResponse, setShowSuggestionResponse] = useState(true);
  const [isSourcesOpen, setIsSourcesOpen] = useState(false);
  const [isSourcesClosing, setIsSourcesClosing] = useState(false);
  const [isTopRecoLoading, setIsTopRecoLoading] = useState(false);
  const [showTopRecommendation, setShowTopRecommendation] = useState(false);
  const [selectedTopReco, setSelectedTopReco] = useState('');
  const [courseResults, setCourseResults] = useState([]);
  const lng = localStorage.getItem('lng') ? localStorage.getItem('lng') : 'en';
  const [aiSearchInfoHubHtml, setaiSearchInfoHubHtml] = useState(null);
  const newSearchButtonRef = useRef(null);
   useEffect(() => {
    const aemAiSearchURL = `${config.AEM_API_BASE_PATH}/content/experience-fragments/vsbdr/${config?.aemUrlEnv}/${lng}/ai/new-search/master.html`;
    getInfoHubHtml(aemAiSearchURL)
      .then((response) => {setaiSearchInfoHubHtml(response?.data)})

    }, [lng]);

  const [custOverrideXfHtml, setCustOverrideXfHtml] = useState(null);
  useEffect(() => {
    const custOverrideXfURL = `${config.AEM_API_BASE_PATH}/content/experience-fragments/vsbdr/${config?.aemUrlEnv}/${lng}/ai/api_failure_response/master.html`;
    getInfoHubHtml(custOverrideXfURL)
      .then((response) => { setCustOverrideXfHtml(response?.data); });
  }, [lng]);
//  console.log('^^custOverrideXfHtml:', custOverrideXfHtml);
  useEffect(() => {
    try {
      if (selectedTopReco && String(selectedTopReco).trim() !== '') {
        localStorage.setItem('selectedTopReco', selectedTopReco);
      } else {
        localStorage.removeItem('selectedTopReco');
      }
    } catch (e) {}
  }, [selectedTopReco]);


  const [selectedTopRecoSuggestion, setSelectedTopRecoSuggestion] =
    useState('');
  const [isTopRecoSourcesOpen, setIsTopRecoSourcesOpen] = useState(false);
  const [isTopRecoSourcesClosing, setIsTopRecoSourcesClosing] = useState(false);
  const [topRecoSelectedThumb, setTopRecoSelectedThumb] = useState(null);
  const [topRecoShowFeedbackPanel, setTopRecoShowFeedbackPanel] =
    useState(false);
  const [topRecoIsFeedbackClosing, setTopRecoIsFeedbackClosing] =
    useState(false);
  const [isTopRecoSuggestionLoading, setIsTopRecoSuggestionLoading] =
    useState(false);
  const [showTopRecoSuggestionResponse, setShowTopRecoSuggestionResponse] =
    useState(false);
  const [topRecoSuggestionSelectedThumb, setTopRecoSuggestionSelectedThumb] =
    useState(null);
  const [
    topRecoSuggestionShowFeedbackPanel,
    setTopRecoSuggestionShowFeedbackPanel,
  ] = useState(false);
  const [
    topRecoSuggestionIsFeedbackClosing,
    setTopRecoSuggestionIsFeedbackClosing,
  ] = useState(false);
  const [showNewSearchModal, setShowNewSearchModal] = useState(false);
  const [showLangSwitchModal, setShowLangSwitchModal] = useState(false);
  const [hideResponseSection, setHideResponseSection] = useState(false);
  const [showInlineSearch, setShowInlineSearch] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  const [isChatLoading, setIsChatLoading] = useState(false);
  const suggestionTimerRef = useRef(null);
  const topRecoTimerRef = useRef(null);
  const topRecoSuggestionTimerRef = useRef(null);
  const inlineSearchTimerRef = useRef(null);
  const toggleTransitionTimerRef = useRef(null);
  const suggestionSectionRef = useRef(null);
  const topRecommendationSectionRef = useRef(null);
  const topRecoSuggestionSectionRef = useRef(null);
  const pendingScrollTargetRef = useRef(null);
  const actionBarWrapperRef = useRef(null);
  const actionBarContentRef = useRef(null);
  const actionBarOriginalTopRef = useRef(0);
  const actionBarHideTimerRef = useRef(null);
  const actionBarRevealTimerRef = useRef(null);
  const actionBarRevealRafRef = useRef([]);
  const isActionBarRevealPendingRef = useRef(false);
  const lastScrollYRef = useRef(0);
  const sessionIdRef = useRef(null);
  const globalIdRef = useRef(null);
  const abortControllerRef = useRef(null);
  const aiSearchScriptLoadedRef = useRef(false);
  // Preserve scroll position across Ask AI / classic search toggle.
  const scrollByModeRef = useRef({ askai: 0, search: 0 });
  const pendingScrollRestoreRef = useRef(null);
  const askAiData = useSelector((state) => state.Aem?.aemAiSearchData);
  const toggleTextsData = askAiData?.resultsPageTexts?.toggleData;
  const learningFilterTopicsData = useSelector((state) => state.Aem?.learningFilterTopicsData);
   const selectedTopics = useSelector(
    (state) => state.Aem?.registrationStepsData?.businessData?.topics
  );
  const [fromMessage, setFromMessage] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchCount, setSearchCount] = useState(0);
  const [footerInputValue, setFooterInputValue] = useState('');
  const [isActionBarPinned, setIsActionBarPinned] = useState(false);
  const [isActionBarVisible, setIsActionBarVisible] = useState(false);
  const [isActionBarTransitionReady, setIsActionBarTransitionReady] = useState(false);
  const [actionBarHeight, setActionBarHeight] = useState(0);
  const isActionBarPinnedRef = useRef(false);
  const isActionBarVisibleRef = useRef(false);
  const isActionBarTransitionReadyRef = useRef(false);
  const isSearchDisabled = showTopRecommendation && searchCount >= 3;
  const params = new URLSearchParams(location.search);
  const initialQuery = params.get('q') || '';
  const [localSearchQuery, setLocalSearchQuery] = useState(initialQuery ? initialQuery : '');
  const [initialClassicFilter, setInitialClassicFilter] = useState('All');
  const isAnyModalOpen = showNewSearchModal || showLangSwitchModal;

  const getGptSessionId = () => {
    if (!sessionIdRef.current) {
      let sid = sessionStorage.getItem('gptSessionID');
      if (!sid) {
        sid = crypto.randomUUID();
        sessionStorage.setItem('gptSessionID', sid);
      }
      sessionIdRef.current = sid;
    }
    return sessionIdRef.current;
  };

  const resetGptSessionId = () => {
    const newsid = crypto.randomUUID();
    try {
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem('gptSessionID', newsid);
      }
    } catch (e) {
      console.log("session error")
    }
    sessionIdRef.current = newsid;
    return sessionIdRef.current;
  };

  const getGlobalId = () => {
    if (!globalIdRef.current) {
      let gid = localStorage.getItem('gptGlobalID');
      if (!gid) {
        gid = crypto.randomUUID();
        localStorage.setItem('gptGlobalID', gid);
      }
      globalIdRef.current = gid;
    }
    return globalIdRef.current;
  };
  
  const getVegasId = () => crypto.randomUUID();

   const switchSectionWithTransition = (nextIsAskAI) => {
    if (nextIsAskAI === renderedIsAskAI && nextIsAskAI === isAskAI) {
      return;
    }

    setIsAskAI(nextIsAskAI);
    setToggleContentPhase('exiting');

    if (toggleTransitionTimerRef.current) {
      clearTimeout(toggleTransitionTimerRef.current);
    }

    toggleTransitionTimerRef.current = setTimeout(() => {
      setRenderedIsAskAI(nextIsAskAI);
      setToggleContentPhase('entering');
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          setToggleContentPhase('entered');
        });
      });
    }, TOGGLE_EXIT_DURATION);
  };

  const handleViewMixedResults = (targetQuery, filterType = 'All') => {
    setInitialClassicFilter(filterType);
    setLocalSearchQuery(targetQuery);
    // setIsAskAI(false); 
    switchSectionWithTransition(false);
  };

  const callVzgptChat = async (message, displayMessage = message) => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;
    const vegasId = getVegasId();

    setChatHistory(prev => [
      ...prev,
      { query: displayMessage, vegasId, streamingText: '', finalText: '', followUpQuestions: [], courseResults: [], citations: [], followUpQuestionText: '', error: null, isStreaming: true },
    ]);
    setIsChatLoading(true);
    setShowAiResponse(true);
    setHideResponseSection(false);
    setShowInlineSearch(false);
    setSearchCount((c) => c + 1);
    try {
      const response = await postVzgptChat({
        userId: '',
        sessionId: getGptSessionId(),
        message,
        vegasId,
        signal: controller.signal,
        globalId: getGlobalId(),
      });

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let accumulatedText = '';
      let finalText = '';
      let allFollowUps = [];
      let allCourseResults = [];
      let allCitations = [];
      let latestFollowUpQuestionText = '';
      let buffer = '';
      let isOverrideVal;
      let overrideScenarioVal;
      let tempText = '';
      let tempFlagVal;
      let hasSourcesMoreThanSixVal;
      let isSSEOverrideVal;

      // eslint-disable-next-line no-constant-condition
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';

        for (const line of lines) {
          const trimmedLine = line.trim();
          if (!trimmedLine.startsWith('data:')) continue;
          const jsonStr = trimmedLine.slice(5).trim();
          if (!jsonStr) continue;

          const { text, isComplete, followUpQuestions, citations, courseResults: incomingCourses, followUpQuestionText, isOverride, overrideScenario, tempFlag, hasSourcesMoreThanSix, isSSEOverride } = parseSSEChunk(jsonStr);
          if (followUpQuestionText) latestFollowUpQuestionText = followUpQuestionText;
          if (followUpQuestions.length > 0) allFollowUps = followUpQuestions;
          if (incomingCourses && incomingCourses.length > 0) {
            setCourseResults(incomingCourses);
            allCourseResults = incomingCourses;
          }
          if(isOverride !== undefined) isOverrideVal = isOverride;
          if(isSSEOverride !== undefined) isSSEOverrideVal = isSSEOverride;
          if(overrideScenario) overrideScenarioVal = overrideScenario;
          if (citations.length > 0) allCitations = citations;
          if(hasSourcesMoreThanSix) hasSourcesMoreThanSixVal = hasSourcesMoreThanSix;
          if (typeof tempFlag !== 'undefined') tempFlagVal = tempFlag;
          if (isComplete && text) finalText = text;
          else if (text && tempFlag) tempText = text;
          else if (text) accumulatedText += text;

          setChatHistory(prev => {
            const updated = [...prev];
            const lastIdx = updated.length - 1;
            updated[lastIdx] = {
              ...updated[lastIdx],
              streamingText: finalText || accumulatedText || tempText,
              tempFlag: tempFlagVal,
              tempTxt: tempText,
              followUpQuestions: allFollowUps,
              courseResults: allCourseResults,
              followUpQuestionText: latestFollowUpQuestionText,
              citations: allCitations,
              isOverride: isOverrideVal,
              overrideScenario: overrideScenarioVal,
              hasSourcesMoreThanSix: hasSourcesMoreThanSixVal,
              isSSEOverride: isSSEOverrideVal,
            };
            return updated;
          });
        }
      }

      setChatHistory(prev => {
        const updated = [...prev];
        const lastIdx = updated.length - 1;
        updated[lastIdx] = {
          ...updated[lastIdx],
          finalText: finalText || accumulatedText || tempText,
          tempFlag: tempFlagVal,
          tempTxt: tempText,
          streamingText: '',
          isStreaming: false,
           courseResults: allCourseResults,
          followUpQuestions: allFollowUps,
          followUpQuestionText: latestFollowUpQuestionText,
          citations: allCitations,
          isOverride: isOverrideVal,
          overrideScenario: overrideScenarioVal,
          hasSourcesMoreThanSix: hasSourcesMoreThanSixVal,
          isSSEOverride: isSSEOverrideVal,
        };
        return updated;
      });
       viewSearchResults(message, 'AI Search', allCourseResults.length, 'AI');
          } catch (error) {
      if (error.name !== 'AbortError') {
        setChatHistory(prev => {
          const updated = [...prev];
          const lastIdx = updated.length - 1;
          updated[lastIdx] = {
            ...updated[lastIdx],
            finalText: '',
            streamingText: '',
            isStreaming: false,
            error:  'Something went wrong. Please try again.',
            isError : true,
          };
          return updated;
        });
      }
    } finally {
      setIsChatLoading(false);
      abortControllerRef.current = null;
    }
  };

  const handleFollowUpPillClick = (suggestion) => {
    const prefix = '';
    const isFirstFollowUp = chatHistory.length === 1;
    const displayMessage = isFirstFollowUp && prefix ? `${prefix} ${suggestion}` : suggestion;
  contentClick(suggestion, window.location.href, '', 'follow ups' );
    callVzgptChat(suggestion, displayMessage);
  };

  const handleNewSearchConfirm = () => {
    if (suggestionTimerRef.current) clearTimeout(suggestionTimerRef.current);
    if (topRecoTimerRef.current) clearTimeout(topRecoTimerRef.current);
    setShowAiResponse(false);
    setInitialSelectedThumb(null);
    setInitialShowFeedbackPanel(false);
    setInitialIsFeedbackClosing(false);
    setSuggestionSelectedThumb(null);
    setSuggestionShowFeedbackPanel(false);
    setSuggestionIsFeedbackClosing(false);
    setSelectedSuggestion('');
    setIsSuggestionLoading(false);
    setShowSuggestionResponse(true);
    setIsSourcesOpen(false);
    setIsSourcesClosing(false);
    setIsTopRecoLoading(false);
    setShowTopRecommendation(false);
    setSelectedTopReco('');
    setSelectedTopRecoSuggestion('');
    setIsTopRecoSourcesOpen(false);
    setIsTopRecoSourcesClosing(false);
    setTopRecoSelectedThumb(null);
    setTopRecoShowFeedbackPanel(false);
    setTopRecoIsFeedbackClosing(false);
    setIsTopRecoSuggestionLoading(false);
    setShowTopRecoSuggestionResponse(false);
    setTopRecoSuggestionSelectedThumb(null);
    setTopRecoSuggestionShowFeedbackPanel(false);
    setTopRecoSuggestionIsFeedbackClosing(false);
    setShowNewSearchModal(false);
    setShowAiResponse(false);
    setChatHistory([]);
    setIsChatLoading(false);
    setHideResponseSection(true);
    setLocalSearchQuery('');
    setInitialClassicFilter('All');
    setFooterInputValue('');
    setCourseResults([]);
    resetGptSessionId();

    if (inlineSearchTimerRef.current) {
      clearTimeout(inlineSearchTimerRef.current);
    }
    if (topRecoSuggestionTimerRef.current) {
      clearTimeout(topRecoSuggestionTimerRef.current);
    }

    setShowInlineSearch(false);
    inlineSearchTimerRef.current = setTimeout(() => {
      setShowInlineSearch(true);
    }, INLINE_SEARCH_REVEAL_DELAY);
    localStorage.removeItem('recSearch');
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };

  const handleModeToggle = () => {
    const currentKey = isAskAI ? 'askai' : 'search';
    const nextKey = isAskAI ? 'search' : 'askai';
    scrollByModeRef.current[currentKey] = window.scrollY || window.pageYOffset || 0;
    pendingScrollRestoreRef.current = scrollByModeRef.current[nextKey];
    switchSectionWithTransition(!isAskAI);
  };

  useEffect(() => {
    if (pendingScrollRestoreRef.current === null) return undefined;
    const targetY = pendingScrollRestoreRef.current;
    pendingScrollRestoreRef.current = null;
    // Wait one frame so the new view has laid out before restoring scroll.
    const rafId = window.requestAnimationFrame(() => window.scrollTo(0, targetY));
    return () => window.cancelAnimationFrame(rafId);
  }, [isAskAI]);

  const actionBarShouldBeVisible =
    isActionBarVisible && !isActionBarRevealPendingRef.current;

  useEffect(() => {
    return () => {
      if (toggleTransitionTimerRef.current) {
        clearTimeout(toggleTransitionTimerRef.current);
      }
    };
  }, []);

  const handleSourcesToggle = () => {
    if (isSourcesOpen) {
      setIsSourcesClosing(true);
    } else {
      setIsSourcesOpen(true);
    }
  };

  const handleSourcesPanelAnimationEnd = () => {
    if (isSourcesClosing) {
      setIsSourcesClosing(false);
      setIsSourcesOpen(false);
    }
  };

  const openInitialFeedbackPanel = () => {
    setInitialIsFeedbackClosing(false);
    setInitialShowFeedbackPanel(true);
  };

  const handleInitialThumbClick = (thumbType) => {
    setInitialSelectedThumb(thumbType);
    //  contentClick(
    //     thumbType,
    //     window.location.href,
    //     '', 
    //     'feedback_form_thumb_click',
    //   );
    openInitialFeedbackPanel();
  };

  const closeInitialFeedbackPanel = () => {
    setInitialIsFeedbackClosing(true);
  };

  const handleInitialFeedbackAnimationEnd = () => {
    if (initialIsFeedbackClosing) {
      setInitialShowFeedbackPanel(false);
      setInitialIsFeedbackClosing(false);
    }
  };

  const openSuggestionFeedbackPanel = () => {
    setSuggestionIsFeedbackClosing(false);
    setSuggestionShowFeedbackPanel(true);
  };

  const handleSuggestionThumbClick = (thumbType) => {
    setSuggestionSelectedThumb(thumbType);
    openSuggestionFeedbackPanel();
  };

  const closeSuggestionFeedbackPanel = () => {
    setSuggestionIsFeedbackClosing(true);
  };

  const handleTopRecoSourcesToggle = () => {
    if (isTopRecoSourcesOpen) {
      setIsTopRecoSourcesClosing(true);
    } else {
      setIsTopRecoSourcesOpen(true);
    }
  };

  const handleTopRecoSourcesPanelAnimationEnd = () => {
    if (isTopRecoSourcesClosing) {
      setIsTopRecoSourcesClosing(false);
      setIsTopRecoSourcesOpen(false);
    }
  };

  const handleTopRecoThumbClick = (thumbType) => {
    setTopRecoSelectedThumb(thumbType);
    setTopRecoIsFeedbackClosing(false);
    setTopRecoShowFeedbackPanel(true);
  };

  const closeTopRecoFeedbackPanel = () => {
    setTopRecoIsFeedbackClosing(true);
  };

  const handleTopRecoFeedbackAnimationEnd = () => {
    if (topRecoIsFeedbackClosing) {
      setTopRecoShowFeedbackPanel(false);
      setTopRecoIsFeedbackClosing(false);
    }
  };

  const handleTopRecoClick = (text) => {
    pendingScrollTargetRef.current = 'topRecommendation';
    setSelectedTopReco(text);
    setShowTopRecommendation(false);
    setIsTopRecoLoading(true);
    setSelectedTopRecoSuggestion('');
    setIsTopRecoSuggestionLoading(false);
    setShowTopRecoSuggestionResponse(false);
    setTopRecoSuggestionSelectedThumb(null);
    setTopRecoSuggestionShowFeedbackPanel(false);
    setTopRecoSuggestionIsFeedbackClosing(false);

    if (topRecoTimerRef.current) {
      clearTimeout(topRecoTimerRef.current);
    }
    if (topRecoSuggestionTimerRef.current) {
      clearTimeout(topRecoSuggestionTimerRef.current);
    }

    topRecoTimerRef.current = setTimeout(() => {
      setIsTopRecoLoading(false);
      setShowTopRecommendation(true);
    }, 3000);
  };

  useEffect(() => {
    if (searchCount > 3 && !showTopRecommendation) {
      setShowTopRecommendation(true); 
    }
  }, [searchCount, showTopRecommendation]);

  const handleTopRecoSuggestionClick = (suggestion) => {
    pendingScrollTargetRef.current = 'topRecoSuggestion';
    setSelectedTopRecoSuggestion(suggestion);
    setShowTopRecoSuggestionResponse(false);
    setIsTopRecoSuggestionLoading(true);

    if (topRecoSuggestionTimerRef.current) {
      clearTimeout(topRecoSuggestionTimerRef.current);
    }

    topRecoSuggestionTimerRef.current = setTimeout(() => {
      setIsTopRecoSuggestionLoading(false);
      setShowTopRecoSuggestionResponse(true);
      setSearchCount((c) => c + 1);
    }, 3000);
  };

  const handleSuggestionClick = (suggestion) => {
    pendingScrollTargetRef.current = 'suggestion';
    setHideResponseSection(false);
    setShowInlineSearch(false);
    setSelectedSuggestion(suggestion);
    setShowSuggestionResponse(true);
    setIsSuggestionLoading(true);

    if (suggestionTimerRef.current) {
      clearTimeout(suggestionTimerRef.current);
    }

    suggestionTimerRef.current = setTimeout(() => {
      setIsSuggestionLoading(false);
      setShowSuggestionResponse(true);
      setSearchCount((c) => c + 1);
    }, 3000);
  };

  const handleSuggestionFeedbackAnimationEnd = () => {
    if (suggestionIsFeedbackClosing) {
      setSuggestionShowFeedbackPanel(false);
      setSuggestionIsFeedbackClosing(false);
    }
  };

  const handleTopRecoSuggestionThumbClick = (thumbType) => {
    setTopRecoSuggestionSelectedThumb(thumbType);
    setTopRecoSuggestionIsFeedbackClosing(false);
    setTopRecoSuggestionShowFeedbackPanel(true);
  };

  const closeTopRecoSuggestionFeedbackPanel = () => {
    setTopRecoSuggestionIsFeedbackClosing(true);
  };

  const handleTopRecoSuggestionFeedbackAnimationEnd = () => {
    if (topRecoSuggestionIsFeedbackClosing) {
      setTopRecoSuggestionShowFeedbackPanel(false);
      setTopRecoSuggestionIsFeedbackClosing(false);
    }
  };

   useEffect(() => {
    const onMsg = (e) => {
      if (e.origin !== window.location.origin) return;
      if (e.data && typeof e.data.from === 'string') setFromMessage(e.data.from);
    };
    window.addEventListener('message', onMsg);
    return () => window.removeEventListener('message', onMsg);
  }, []);

  const getReferrerPath = () => {
    try {
      const ref = document.referrer;
      if (!ref) return null;
      const r = new URL(ref);
      if (r.origin !== window.location.origin) return null;
      return r.pathname + r.search + r.hash;
    } catch {
      return null;
    }
  };

  useEffect(() => {
    const urlQuery = params.get('q');
    if (urlQuery) {
      const decodedQuery = urlQuery;
      localStorage.setItem('firstQuery', decodedQuery);
      // Maintain a recent-search list in localStorage. Prepend the current query
      // so the most recent search is always first: ['newquery', 'abc', 'def'].
      try {
        if (decodedQuery && decodedQuery.trim() !== '') {
          let recSearch = [];
          const storedRecSearch = localStorage.getItem('recSearch');
          if (storedRecSearch) {
            const parsed = JSON.parse(storedRecSearch);
            if (Array.isArray(parsed)) {
              recSearch = parsed;
            }
          }
          // If the query already exists, remove it first so it moves to the top.
          recSearch = recSearch.filter((item) => item !== decodedQuery);
          recSearch.unshift(decodedQuery);
          recSearch = recSearch.slice(0, 5);
          localStorage.setItem('recSearch', JSON.stringify(recSearch));
        }
      } catch (e) {
        console.error('recSearch localStorage error:', e);
      }
      callVzgptChat(decodedQuery);
    }
    pageLoadStarted("Ask AI",window.location.origin + localStorage.getItem('prevUrl'),
    selectedTopics?.toString());
    pageLoadCompleted();
  }, []);

  useEffect(() => {
    return () => {
      if (suggestionTimerRef.current) {
        clearTimeout(suggestionTimerRef.current);
      }
      if (topRecoTimerRef.current) {
        clearTimeout(topRecoTimerRef.current);
      }
      if (topRecoSuggestionTimerRef.current) {
        clearTimeout(topRecoSuggestionTimerRef.current);
      }
      if (inlineSearchTimerRef.current) {
        clearTimeout(inlineSearchTimerRef.current);
      }
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  useEffect(() => {
    const scrollTargetMap = {
      suggestion: suggestionSectionRef,
      topRecommendation: topRecommendationSectionRef,
      topRecoSuggestion: topRecoSuggestionSectionRef,
    };

    const scrollTarget = pendingScrollTargetRef.current;
    const sectionRef = scrollTargetMap[scrollTarget];

    if (!sectionRef?.current) {
      return;
    }

    let animationFrameId = null;

    const startAnimationFrameId = window.requestAnimationFrame(() => {
      const targetElement = sectionRef.current;

      if (!targetElement) {
        pendingScrollTargetRef.current = null;
        return;
      }

      const startY = window.scrollY;
      const targetY = window.scrollY + targetElement.getBoundingClientRect().top;
      const distance = targetY - startY;

      if (Math.abs(distance) < 4) {
        pendingScrollTargetRef.current = null;
        return;
      }

      const startTime = performance.now();

      const animateScroll = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / SECTION_SCROLL_DURATION, 1);
        const easedProgress = easeInOutCubic(progress);

        window.scrollTo({
          top: startY + distance * easedProgress,
          left: 0,
          behavior: 'auto',
        });

        if (progress < 1) {
          animationFrameId = window.requestAnimationFrame(animateScroll);
          return;
        }

        pendingScrollTargetRef.current = null;
      };

      animationFrameId = window.requestAnimationFrame(animateScroll);
    });

    return () => {
      window.cancelAnimationFrame(startAnimationFrameId);

      if (animationFrameId) {
        window.cancelAnimationFrame(animationFrameId);
      }
    };
  }, [
    isSuggestionLoading,
    showSuggestionResponse,
    isTopRecoLoading,
    showTopRecommendation,
    isTopRecoSuggestionLoading,
    showTopRecoSuggestionResponse,
  ]);

  useEffect(() => {
    const originalHtmlOverflow = document.documentElement.style.overflow;
    const originalOverflow = document.body.style.overflow;

    if (showNewSearchModal || showLangSwitchModal) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.documentElement.style.overflow = originalHtmlOverflow;
      document.body.style.overflow = originalOverflow;
    };
  }, [showNewSearchModal,showLangSwitchModal]);
  
  const appendAskAiToUrl = (originalUrl, searchQuery) => {
      if (!originalUrl) return '';
      try {
        const url = new URL(originalUrl);
        const gotoParam = url.searchParams.get('goto');

        if (gotoParam) {
          const gotoUrl = new URL(gotoParam);
          
          gotoUrl.pathname = gotoUrl.pathname.endsWith('/') 
            ? `${gotoUrl.pathname}askai` 
            : `${gotoUrl.pathname}/askai`;
            
          if (searchQuery) {
            gotoUrl.searchParams.set('q', searchQuery);
          }

          url.searchParams.set('goto', gotoUrl.toString());
          return url.toString();
        }
        
        return originalUrl;
      } catch (error) {
        console.error('Failed to parse URL:', error);
        return originalUrl; 
      }
    };
  let searchQuery = ''; 
  if (footerInputValue && footerInputValue.trim() !== '') {
    searchQuery = footerInputValue.trim();
  } else {
    try {
      const params = new URLSearchParams(window.location.search);
      searchQuery = params.get('q') || '';
    } catch (e) {
      searchQuery = '';
    }
  }

  const searchQueryParam = searchQuery ? `?q=${encodeURIComponent(searchQuery)}` : '';
  const signinAEMUrl = learningFilterTopicsData?.regDlts?.signInLink || '';
  const regLinkFromRedux = learningFilterTopicsData?.regDlts?.regLink || '/onboarding';

  const handleSignInClick = () => {
    if (!signinAEMUrl) {
      console.error('Sign-in URL is missing from Redux data');
      return; 
    }

    // Call the helper function from Step 1
    const updatedUrl = appendAskAiToUrl(signinAEMUrl, searchQuery);
    
    // Save to localStorage
    const prevUrlString = `/askai${searchQueryParam}`;
    localStorage.setItem('prevUrl', prevUrlString);
    console.log('Saved to localStorage:', localStorage.getItem('prevUrl'));

    // Redirect the user
    window.location.href = updatedUrl;
  };

  const setCookie = (name, value, minutes = 15) => {
    try {
      const maxAge = Math.round(minutes * 60);
      // IMPORTANT: set Domain to the shared parent domain
      document.cookie = `${name}=${encodeURIComponent(value)}; Domain=.ebiz.verizon.com; Path=/; Max-Age=${maxAge}; SameSite=None; Secure`;
    } catch (e) {}
  };

  // ADD THIS NEW USE-EFFECT
  useEffect(() => {
    const handleGnavAccountClick = (event) => {
      console.log('Click event detected on global navigation:', event.target)
      // Check if the clicked element or any of its parents have the target classes
      const clickedElement = event.target.closest('#gnav20-account-link-id, #gnav20-account-link-id-mobile');
      
      if (clickedElement && window.location.pathname.includes('/askai')) {
        const prevUrlString = `/askai${searchQueryParam}`;
        console.log('Setting cookie askai_prev with value:', prevUrlString);
        setCookie('askai_prev', prevUrlString, 15);
      }
    };

    // Attach to document to catch clicks on the global navigation
    document.addEventListener('click', handleGnavAccountClick);

    return () => {
      document.removeEventListener('click', handleGnavAccountClick);
    };
  }, [searchQueryParam]);

  const handleRegisterClick = () => {
    const targetUrl = searchQuery 
      ? `${regLinkFromRedux}?q=${encodeURIComponent(searchQuery)}` 
      : regLinkFromRedux;
    const prevUrlString = `/askai${searchQueryParam}`;
    setCookie('askai_prev', prevUrlString, 15);
    window.location.href = targetUrl;
  };
  const originalSwitchActionRef = useRef(null);

const handleLangSwitchConfirm = () => {
  setIsAskAI(false);
  window.isAskAIActive = false;
  setShowLangSwitchModal(false);
  const prevUrl = localStorage.getItem('prevUrl');

  const fromState = location.state?.from;
  let target = prevUrl || fromState || fromMessage || getReferrerPath() || '/';
  try {
    const parsed = new URL(target, window.location.origin);
    if (parsed.pathname && parsed.pathname.includes('/askai')) {
      const ref = getReferrerPath();
       if (prevUrl && !String(prevUrl).includes('/askai')) target = prevUrl;
        else if (fromMessage && !fromMessage.includes('/askai')) target = fromMessage;
        else if (ref && !ref.includes('/askai')) target = ref;
        else target = '/';
    }
  } catch (e) {
    target = '/';
  }

  try {
    localStorage.setItem('lng', 'es');
    localStorage.setItem('changedLanguage', 'es');
    sessionStorage.setItem('isSwitchedLanguage', 'true');
  } catch (e) {}

  try {
    window.gnavdl = window.gnavdl || {};
    window.gnavdl.variation = 'prospect-es';
  } catch (e) {}

  if (window.i18n && typeof window.i18n.changeLanguage === 'function') {
    try { window.i18n.changeLanguage('es'); } catch (e) {}
  }

  const buildSpanishHref = (href) => {
    try {
      const u = new URL(href, window.location.origin);
      if (u.pathname.startsWith('/es')) return u.pathname + u.search + u.hash;
      return '/es' + u.pathname + u.search + u.hash;
    } catch (e) {
      return '/es';
    }
  };

  const spanishTarget = buildSpanishHref(target);

  window.location.href = spanishTarget;
};


// const handleBackClick = () => {
//   try {
//     const prev = localStorage.getItem('prevUrl');
//     if (prev && String(prev).trim() !== '') {
//       // If prev contains askai anywhere, don't go back to askai — go home
//       if (prev.includes('/askai')) {
//         window.location.href = '/';
//         return;
//       }
//       try {
//         const parsed = new URL(prev, window.location.origin);
//         if (parsed.pathname && parsed.pathname.includes('/askai')) {
//           window.location.href = '/';
//           return;
//         }
//       } catch (e) {
//         // ignore parse errors for relative paths
//       }

//       // Navigate to the stored prev (support absolute and relative)
//       if (/^https?:\/\//i.test(prev)) window.location.href = prev;
//       else window.location.href = prev.startsWith('/') ? prev : `/${prev}`;
//       return;
//     }

//     // Fallback: use same-origin referrer if available and not askai
//     const ref = document.referrer;
//     if (ref) {
//       try {
//         const r = new URL(ref);
//         if (r.pathname && r.pathname.includes('/askai')) {
//           window.location.href = '/';
//           return;
//         }
//         if (r.origin === window.location.origin) {
//           window.location.href = ref;
//           return;
//         }
//       } catch (e) {}
//     }
//   } catch (e) {}

//   window.location.href = '/';
// };

 const handleBackClick = () => {
    let targetUrl = '/'; // Default fallback

    try {
      const prev = localStorage.getItem('prevUrl');
      if (prev && String(prev).trim() !== '') {
        // If prev contains askai anywhere, don't go back to askai — go home
        if (prev.includes('/askai')) {
          targetUrl = '/';
        } else {
          let isAskAi = false;
          try {
            const parsed = new URL(prev, window.location.origin);
            if (parsed.pathname && parsed.pathname.includes('/askai')) {
              isAskAi = true;
            }
          } catch (e) {
            // ignore parse errors for relative paths
          }
          
          if (isAskAi) {
            targetUrl = '/';
          } else if (/^https?:\/\//i.test(prev)) {
            targetUrl = prev;
          } else {
            targetUrl = prev.startsWith('/') ? prev : `/${prev}`;
          }
        }
      } else {
        // Fallback: use same-origin referrer if available and not askai
        const ref = document.referrer;
        if (ref) {
          try {
            const r = new URL(ref);
            if (r.pathname && r.pathname.includes('/askai')) {
              targetUrl = '/';
            } else if (r.origin === window.location.origin) {
              targetUrl = ref;
            }
          } catch (e) {}
        }
      }
    } catch (e) {}
console.log('^^ targetUrl:', targetUrl);
 const fullAbsoluteUrl = new URL(targetUrl, window.location.origin).href;
    // Fire the analytics event with the dynamically calculated targetUrl
    contentClick(
      askAiData?.resultsPageTexts?.bckBtnText || 'Back',
      fullAbsoluteUrl,
      '',
      'askai_back_button'
    );

    // Finally, trigger the navigation
   window.location.href = targetUrl;
  };

  // Sync active boolean to global scope and capture standard navbar click event pipelines
  useEffect(() => {
    window.isAskAIActive = true;

    const handleIntercept = (event) => {
      originalSwitchActionRef.current = event.detail.proceedWithSwitch;
      setShowLangSwitchModal(true);
    };

    window.addEventListener('gnav-intercept-lang', handleIntercept);
    return () => {
      window.removeEventListener('gnav-intercept-lang', handleIntercept);
    };
  }, []);

  const getToggleLabel = (key) => {
    const item = toggleTextsData?.find((t) => t.key === key);
    return item?.toggleLbl ?? '';
  };

  // const handleToggle = () => {
  //   const firstQuery = localStorage.getItem('firstQuery');
  //   const queryString = firstQuery ? `?q=${encodeURIComponent(firstQuery)}` : '';
  //   setIsAskAI((prev) => {
  //     const next = !prev;
  //     const activeKey = next ? 'askai' : 'search';
  //     console.log('Toggle status:', getToggleLabel(activeKey));
  //     if (activeKey === 'search') {
  //       window.location.href = `/classic-search${queryString}`;
  //     } else if (activeKey === 'askai') {
  //       window.location.href = `/askai${queryString}`;
  //     }
  //     return next;
  //   });
  // };

  useEffect(() => {
    const responseTimer = setTimeout(() => {
    setShowAiResponse(true);
    setSearchCount((c) => c + 1);
    }, 3000);

    return () => clearTimeout(responseTimer);
    }, []);

  // The AEM aisearch.js binds to DOM nodes (#searchInput, #searchBtn, etc.) that live
  // inside the Info Hub HTML injected via dangerouslySetInnerHTML. That HTML is only
  // rendered once (hideResponseSection && showInlineSearch) becomes true, which happens
  // after the script would run if loaded via Helmet. Loading it there makes
  // getElementById('searchInput') return null so no listeners attach and typing does
  // nothing. Instead, load the script once, after the elements exist in the DOM.
  useEffect(() => {
    if (!hideResponseSection || !showInlineSearch || !aiSearchInfoHubHtml) return undefined;
    if (aiSearchScriptLoadedRef.current) return undefined;

    const rafId = window.requestAnimationFrame(() => {
      if (aiSearchScriptLoadedRef.current) return;
      if (!document.getElementById('searchInput')) return;

      const envSuffix =
        config.aemUrlEnv === 'QA1' ? '/QA1' : config.aemUrlEnv === 'QA2' ? '/QA2' : '' ;
      const script = document.createElement('script');
      script.src = `${config.AEM_API_BASE_PATH}${config.aemUrlPath}${envSuffix}/js/aisearch.js`;
      script.async = false;
      script.type = 'text/javascript';
      script.setAttribute('data-aisearch-dynamic', 'true');
      document.body.appendChild(script);
      aiSearchScriptLoadedRef.current = true;
    });

    return () => window.cancelAnimationFrame(rafId);
  }, [ hideResponseSection, showInlineSearch, aiSearchInfoHubHtml]);

  useEffect(() => {
    const clearHideTimer = () => {
      if (actionBarHideTimerRef.current) {
        clearTimeout(actionBarHideTimerRef.current);
        actionBarHideTimerRef.current = null;
      }
    };

    const clearRevealTimer = () => {
      if (actionBarRevealTimerRef.current) {
        clearTimeout(actionBarRevealTimerRef.current);
        actionBarRevealTimerRef.current = null;
      }
      if (actionBarRevealRafRef.current.length > 0) {
        actionBarRevealRafRef.current.forEach((rafId) => {
          window.cancelAnimationFrame(rafId);
        });
        actionBarRevealRafRef.current = [];
      }
      isActionBarRevealPendingRef.current = false;
    };

    const releaseActionBar = () => {
      clearHideTimer();
      clearRevealTimer();
      isActionBarVisibleRef.current = false;
      setIsActionBarVisible(false);
      isActionBarTransitionReadyRef.current = false;
      setIsActionBarTransitionReady(false);
      isActionBarPinnedRef.current = false;
      setIsActionBarPinned(false);
    };

    const scheduleRevealActionBar = () => {
      clearRevealTimer();
      if (!isActionBarPinnedRef.current) return;
      if (isActionBarVisibleRef.current) return;

      isActionBarRevealPendingRef.current = true;
      isActionBarTransitionReadyRef.current = true;
      flushSync(() => {
        setIsActionBarTransitionReady(true);
      });

      if (actionBarContentRef.current) {
        void actionBarContentRef.current.offsetHeight;
      }

      if (!isActionBarPinnedRef.current) {
        isActionBarRevealPendingRef.current = false;
        actionBarRevealRafRef.current = [];
        return;
      }

      isActionBarRevealPendingRef.current = false;
      isActionBarVisibleRef.current = true;
      setIsActionBarVisible(true);
      actionBarRevealRafRef.current = [];
    };

    if (!isAskAI) {
      releaseActionBar();
      return undefined;
    }

    const updateActionBarMetrics = () => {
      if (!actionBarWrapperRef.current || !actionBarContentRef.current) {
        return;
      }

      actionBarOriginalTopRef.current =
        actionBarWrapperRef.current.getBoundingClientRect().top + window.scrollY;
      setActionBarHeight(actionBarContentRef.current.getBoundingClientRect().height);
    };

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const deltaY = currentScrollY - lastScrollYRef.current;

      if (Math.abs(deltaY) < 1) {
        lastScrollYRef.current = currentScrollY;
        return;
      }

      const isScrollingUp = deltaY < 0;
      const actionBarWrapperBottom = actionBarWrapperRef.current
        ? actionBarWrapperRef.current.getBoundingClientRect().bottom
        : Number.POSITIVE_INFINITY;
      const actionBarThreshold = Math.max(actionBarHeight, 0);
      const hasPassedActionBar = actionBarWrapperBottom <= actionBarThreshold;

      // When original position is reached, unpin bar to its original position.
      if (!hasPassedActionBar) {
        clearHideTimer();
        clearRevealTimer();
        if (isActionBarPinnedRef.current) {
          // Bar was pinned, now unpin it to return to normal flow at original position
          isActionBarPinnedRef.current = false;
          setIsActionBarPinned(false);
          isActionBarVisibleRef.current = false;
          setIsActionBarVisible(false);
        }
        lastScrollYRef.current = currentScrollY;
        return;
      }

      if (isScrollingUp) {
        clearHideTimer();
        if (!isActionBarPinnedRef.current) {
          isActionBarPinnedRef.current = true;
          isActionBarVisibleRef.current = false;
          isActionBarTransitionReadyRef.current = false;
          // Commit the hidden pinned frame immediately so reveal always transitions.
          flushSync(() => {
            setIsActionBarPinned(true);
            setIsActionBarVisible(false);
            setIsActionBarTransitionReady(false);
          });
          // Always reveal through the scheduled path so first animation is not skipped.
          scheduleRevealActionBar();
        } else if (!isActionBarVisibleRef.current && !isActionBarRevealPendingRef.current) {
          // Fast scroll-up while pinned still goes through scheduled reveal.
          scheduleRevealActionBar();
        }
      } else if (isActionBarPinnedRef.current) {
        clearHideTimer();
        clearRevealTimer();
        isActionBarVisibleRef.current = false;
        setIsActionBarVisible(false);
        isActionBarTransitionReadyRef.current = true;
        setIsActionBarTransitionReady(true);
        actionBarHideTimerRef.current = setTimeout(() => {
          actionBarHideTimerRef.current = null;
          if (isActionBarVisibleRef.current) return;
          isActionBarPinnedRef.current = false;
          setIsActionBarPinned(false);
        }, ACTION_BAR_TRANSITION_MS);
      }

      lastScrollYRef.current = currentScrollY;
    };

    updateActionBarMetrics();
    lastScrollYRef.current = window.scrollY;

    window.addEventListener('resize', updateActionBarMetrics);
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('resize', updateActionBarMetrics);
      window.removeEventListener('scroll', handleScroll);
      clearHideTimer();
      clearRevealTimer();
    };
  }, [isAskAI]);

  return (
    <>
      {/* {isAskAI && <AskAIPageBanner />} */}
      <div aria-hidden={isAnyModalOpen} inert={isAnyModalOpen ? '' : undefined}>
      {renderedIsAskAI && <AskAIPageBanner />}
      <ContainerWrapper
        maxWidth="1280px"
        margin="0 auto"
        className="pt-0X pb-6X sm-pb-4X"
      >
      {renderedIsAskAI && 
        <>
        <Block padding={isMobile ? '24px 16px 0' : '32px 24px 0'}>  
          <Flex
            gap={isMobile ? '8px' : '12px'}
            marginBottom={isMobile ? '24px' : '32px'}
          >
            { askAiData?.resultsPageTexts?.aiBetaDesc && askAiData?.resultsPageTexts?.aiBetaLabel && <><Block width="24px" marginTop="2px">
              <svg
                width={isMobile ? '20' : '24'}
                height={isMobile ? '20' : '24'}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.9992 11.0625C11.9992 11.3111 12.098 11.5496 12.2738 11.7254C12.4496 11.9012 12.6881 12 12.9367 12C13.1854 12 13.4238 11.9012 13.5996 11.7254C13.7754 11.5496 13.8742 11.3111 13.8742 11.0625C13.8742 10.8139 13.7754 10.5754 13.5996 10.3996C13.4238 10.2238 13.1854 10.125 12.9367 10.125C12.6881 10.125 12.4496 10.2238 12.2738 10.3996C12.098 10.5754 11.9992 10.8139 11.9992 11.0625ZM20.6008 19.3336L16.3187 8.25V4.17188H17.9992V2.57812H5.99922V4.17188H7.67969V8.25L3.39766 19.3336C3.33203 19.507 3.29688 19.6898 3.29688 19.875C3.29688 20.7023 3.96953 21.375 4.79688 21.375H19.2016C19.3867 21.375 19.5695 21.3398 19.743 21.2742C20.5164 20.9766 20.9008 20.107 20.6008 19.3336ZM9.27344 8.54766V4.21875H14.725V8.54766L16.8555 14.0625C16.3703 13.9383 15.8687 13.875 15.3578 13.875C13.9234 13.875 12.5641 14.3789 11.4836 15.2812C10.6862 15.9474 9.6797 16.3117 8.64063 16.3102C7.87422 16.3102 7.13828 16.1156 6.48906 15.7547L9.27344 8.54766ZM4.93281 19.7812L5.91016 17.2547C6.74688 17.6789 7.67734 17.9062 8.64297 17.9062C10.0773 17.9062 11.4367 17.4023 12.5172 16.5C13.3117 15.8391 14.3055 15.4711 15.3602 15.4711C16.1805 15.4711 16.9633 15.6938 17.6477 16.1063L19.0656 19.7812H4.93281Z"
                  fill="black"
                />
              </svg>
            </Block>
            <Flex flexDirection="column" gap="8px">
              <div className="vds-title-xs mobile-vds-body-lg font-eDS-bold">
               {decodeHTML(askAiData?.resultsPageTexts?.aiBetaLabel)}
              </div>
              <div className="vds-body-sm">
                 {decodeHTML(askAiData?.resultsPageTexts?.aiBetaDesc)}
              </div>
            </Flex></>
            }
          </Flex>

        </Block>

          <div ref={actionBarWrapperRef} style={{ height: isActionBarPinned ? `${actionBarHeight}px` : undefined }}>
            <div
              ref={actionBarContentRef}
              style={isActionBarPinned ? {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: SCROLL_UP_STICKY_Z_INDEX,
                background: '#ffffff',
                transform: actionBarShouldBeVisible ? 'translate3d(0, 0, 0)' : 'translate3d(0, -110%, 0)',
                opacity: actionBarShouldBeVisible ? 1 : 0,
                transition: isActionBarTransitionReady
                  ? `transform ${ACTION_BAR_TRANSITION_MS}ms ${ACTION_BAR_EASING}, opacity ${ACTION_BAR_OPACITY_TRANSITION_MS}ms linear`
                  : 'none',
                willChange: 'transform, opacity',
              } : undefined}
            >
              <ContainerWrapper maxWidth="1280px" margin="0 auto">
                <Block padding={isMobile ? '0 16px 24px' : '0 24px 32px'} paddingTop={isActionBarPinned ? (isMobile ? '24px' : '32px') : undefined}>
                  <Flex justifyContent="space-between" alignItems="center">
                    <Flex gap="12px">
                      <HeaderButton $isMobile={isMobile} onClick={handleBackClick} role="button" aria-label="Back">
                        <Icon name="left-arrow" size='medium' />
                        {!isMobile && (
                          <div className="vds-body-lg font-eDS-bold">{askAiData?.resultsPageTexts?.bckBtnText}</div>
                        )}
                      </HeaderButton>
                      <HeaderButton
                        $isMobile={isMobile}
                        ref={newSearchButtonRef}
                        onClick={() => {
                          setShowNewSearchModal(true);
                           contentClick(
                             askAiData?.resultsPageTexts?.newSchBtnText || "New Search",
                            window.location.href,
                            '', 
                            'askai_new_search_button',
                          );
                        }}
                      >
                        {isMobile ? (
                          <Icon name="compose" size='medium' />
                        ) : (
                          <div className="vds-body-lg font-eDS-bold">{askAiData?.resultsPageTexts?.newSchBtnText}</div>
                        )}
                      </HeaderButton>
                    </Flex>

                    <ToggleWrapper>
                      {!isMobile && (
                        <div className="vds-body-lg font-eDS-bold">{getToggleLabel('askai')}</div>
                      )}
                      <SegmentedToggle
                        tabIndex={0}
                        onClick={() => {
                           contentClick(
                              isAskAI ? (getToggleLabel('search') || 'Search') : (getToggleLabel('askai') || 'Ask AI'),
                              window.location.href,
                              '',
                              'askai_toggle_switch'
                            );
                            handleModeToggle();}}
                        role="switch"
                        aria-checked={!isAskAI}
                        aria-label={isAskAI ? 'Switch to Search results' : 'Switch to Ask AI'}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleModeToggle();
                          }
                        }}
                      >
                        <ToggleSlider active={isAskAI} />
                        <ToggleSegment>
                          {isAskAI ?
                            <img  src={askAiData?.resultsPageTexts?.toggleData[0]?.toggleImg}
                                  alt="AI Beta Icon" width='16' height='16'
                                    style={{ filter: 'grayscale(100%) brightness(0)' }} />
                                  :
                            <img  src={askAiData?.resultsPageTexts?.toggleData[0]?.toggleImgWhite}
                                  alt="AI Beta Icon" width='20' height='20' />
                          }

                         
                        </ToggleSegment>
                        <ToggleSegment>
                          {isAskAI ?
                            <img  src={askAiData?.resultsPageTexts?.toggleData[1]?.toggleImgWhite}
                                  alt="AI Beta Icon" width='20' height='20' />
                                  :
                            <img  src={askAiData?.resultsPageTexts?.toggleData[1]?.toggleImg}
                                  alt="AI Beta Icon" width='16' height='16' />
                          }
                        </ToggleSegment>
                      </SegmentedToggle>
                      {!isMobile && (
                        <div
                          className="vds-body-lg font-eDS-bold"
                          style={{ opacity: '17%' }}
                        >
                           {getToggleLabel('search')}
                        </div>
                      )}
                    </ToggleWrapper>
                  </Flex>
                </Block>
              </ContainerWrapper>
            </div>
          </div>

        </>
      }
        {/* {!hideResponseSection && (isAskAI ? ( */}
        {(!hideResponseSection || !renderedIsAskAI) && (
          <ToggleContentTransition $phase={toggleContentPhase}>
            {renderedIsAskAI ? (
          <>
            {!showAiResponse && <AskAIGeneratingResponse />}
{/* cust override ex fragment start */}
<Helmet>
  <link
    href={`${config.AEM_API_BASE_PATH}${config.aemUrlPath}${config.aemUrlEnv === 'QA1' ? '/QA1' : config.aemUrlEnv === 'QA2' ? '/QA2' : ''}/css/custOverride.css`}
    rel='stylesheet'
    type='text/css'
  ></link>
  <script
    src={`${config.AEM_API_BASE_PATH}${config.aemUrlPath}${config.aemUrlEnv === 'QA1' ? '/QA1' : config.aemUrlEnv === 'QA2' ? '/QA2' : ''}/js/custOverride.js`}
    type='text/javascript'
    async
  ></script>
</Helmet>
{/* {custOverrideXfHtml && chatHistory?.[0]?.isError && (
  <div
    dangerouslySetInnerHTML={{
      __html: DOMPurify.sanitize(custOverrideXfHtml),
    }}
  />
)} */}
{/* cust override ex fragment end */}

            {showAiResponse && (
              <AskAIInitialResponse
                isMobile={isMobile}
                custOverrideXfHtml={custOverrideXfHtml}
                chatHistory={chatHistory}
                isChatLoading={isChatLoading}
                handleSuggestionClick={handleFollowUpPillClick}
                selectedThumb={initialSelectedThumb}
                handleThumbClick={handleInitialThumbClick}
                showFeedbackPanel={initialShowFeedbackPanel}
                isFeedbackClosing={initialIsFeedbackClosing}
                closeFeedbackPanel={closeInitialFeedbackPanel}
                handleFeedbackAnimationEnd={handleInitialFeedbackAnimationEnd}
                isSearchDisabled={isSearchDisabled}
                askAiData = {askAiData}
                onViewMixedResults={handleViewMixedResults}
              />
            )}

            {/* {(isTopRecoLoading || showTopRecommendation) && (
              <Flex
                ref={topRecommendationSectionRef}
                flexDirection="column"
                marginTop={isMobile ? '64px' : '128px'}
              >
                {isTopRecoLoading && <AskAIGeneratingResponse />} */}
                {/* {showTopRecommendation && (
                  <>
                    <AskAITopRecommendationSection
                      selectedTopReco={selectedTopReco}
                      isSourcesOpen={isTopRecoSourcesOpen}
                      isSourcesClosing={isTopRecoSourcesClosing}
                      handleSourcesToggle={handleTopRecoSourcesToggle}
                      handleSourcesPanelAnimationEnd={
                        handleTopRecoSourcesPanelAnimationEnd
                      }
                      selectedThumb={topRecoSelectedThumb}
                      handleThumbClick={handleTopRecoThumbClick}
                      showFeedbackPanel={topRecoShowFeedbackPanel}
                      isFeedbackClosing={topRecoIsFeedbackClosing}
                      closeFeedbackPanel={closeTopRecoFeedbackPanel}
                      handleFeedbackAnimationEnd={
                        handleTopRecoFeedbackAnimationEnd
                      }
                      handleSuggestionClick={handleTopRecoSuggestionClick}
                      isMobile={isMobile}
                      isSearchDisabled={isSearchDisabled}
                    />
                  </>
                )} */}
              {/* </Flex>
            )} */}

            {/* {(isTopRecoSuggestionLoading || showTopRecoSuggestionResponse) && (
              <Flex
                ref={topRecoSuggestionSectionRef}
                flexDirection="column"
                marginTop={isMobile ? '64px' : '128px'}
              >
                {isTopRecoSuggestionLoading && <AskAIGeneratingResponse />}
                {showTopRecoSuggestionResponse && (
                  <AskAISuggestionResponse2
                    selectedTopReco={selectedTopRecoSuggestion}
                    isSourcesOpen={isTopRecoSourcesOpen}
                    isSourcesClosing={isTopRecoSourcesClosing}
                    handleSourcesToggle={handleTopRecoSourcesToggle}
                    handleSourcesPanelAnimationEnd={
                      handleTopRecoSourcesPanelAnimationEnd
                    }
                    selectedThumb={topRecoSuggestionSelectedThumb}
                    handleThumbClick={handleTopRecoSuggestionThumbClick}
                    showFeedbackPanel={topRecoSuggestionShowFeedbackPanel}
                    isFeedbackClosing={topRecoSuggestionIsFeedbackClosing}
                    closeFeedbackPanel={closeTopRecoSuggestionFeedbackPanel}
                    handleFeedbackAnimationEnd={
                      handleTopRecoSuggestionFeedbackAnimationEnd
                    }
                  />
                )}
              </Flex>
            )} */}

            {showTopRecommendation && (
              <Flex marginTop={isMobile ? '64px' : '128px'} padding={isMobile ? '0 16px' : '0 24px'}>
                <AskAICtaCard>
                  <div className="vds-title-sm font-eDS-bold">
                     {decodeHTML(askAiData?.resultsPageTexts?.regBannerDlts?.registerCourseText)}
                  </div>
                  <div className="vds-body-md mt-2X">
                     {decodeHTML(askAiData?.resultsPageTexts?.regBannerDlts?.regSubText)}
                  </div>
                  <AskAICtaButtonRow>
                    <AskAICtaPrimaryButton type="button"  onClick={handleRegisterClick}>
                      <span className="vds-body-lg font-eDS-bold  ">
                         {askAiData?.resultsPageTexts?.regBannerDlts?.regButtonText}
                      </span>
                    </AskAICtaPrimaryButton>
                    <AskAICtaSecondaryButton  type="button" onClick={handleSignInClick}>
                      <span className="vds-body-lg font-eDS-bold  ">
                         {askAiData?.resultsPageTexts?.regBannerDlts?.signInText}
                      </span>
                    </AskAICtaSecondaryButton>
                  </AskAICtaButtonRow>
                </AskAICtaCard>
              </Flex>
            )}
          </>
        ) : (
          <SearchResultsComponent query={localSearchQuery} onToggleAskAI={handleModeToggle} initialFilter={initialClassicFilter}/>
        )}
        </ToggleContentTransition>
        )}
     
       {/* ai search component */}

                        { <Helmet>
                            <link
                                // href={'https://mbqa1.sdc.vzwcorp.com/content/dam/vsbdr/clientlibs/QA2/css/herobanner.css'}
                                href={`${config.AEM_API_BASE_PATH}${config.aemUrlPath}${config.aemUrlEnv === 'QA1' ? '/QA1' : config.aemUrlEnv === 'QA2' ? '/QA2' : ''}/css/herobanner.css`}
                                rel='stylesheet'
                                type='text/css'
                            ></link>
                             <link
                                // href={'https://mbqa1.sdc.vzwcorp.com/content/dam/vsbdr/clientlibs/QA2/css/aisearch.css'}
                                href={`${config.AEM_API_BASE_PATH}${config.aemUrlPath}${config.aemUrlEnv === 'QA1' ? '/QA1' : config.aemUrlEnv === 'QA2' ? '/QA2' : ''}/css/aisearch.css`}
                                rel='stylesheet'
                                type='text/css'
                            ></link>
                            <script
                                src={`${config.AEM_API_BASE_PATH}${config.aemUrlPath}${config.aemUrlEnv === 'QA1' ? '/QA1' : config.aemUrlEnv === 'QA2' ? '/QA2' : ''}/js/herobanner.js`}
                                // src={'https://mbqa1.sdc.vzwcorp.com/content/dam/vsbdr/clientlibs/QA2/js/herobanner.js'}
                                type='text/javascript'
                                async
                            ></script>
                            {/* aisearch.js is loaded dynamically after the Info Hub HTML
                                (which contains #searchInput) is injected into the DOM. */}
                             <script
                              src={`${config.AEM_API_BASE_PATH}${config.aemUrlPath}${config.aemUrlEnv === 'QA1' ? '/QA1' : config.aemUrlEnv === 'QA2' ? '/QA2' : ''}/js/aisearchcommon.js`}
                                // src={`https://mbqa1.sdc.vzwcorp.com/content/dam/vsbdr/clientlibs/QA2/js/aisearchcommon.js`}
                              type='text/javascript'
                              async
                            ></script>
                        </Helmet>}
                       {  hideResponseSection && showInlineSearch && <div
                        style={{ display: renderedIsAskAI ? 'block' : 'none' }}
                        aria-hidden={!renderedIsAskAI}
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(aiSearchInfoHubHtml,{ADD_ATTR: ['target']}),
                            }}
                        />}

        {/* {hideResponseSection && showInlineSearch && <InlineSearch  askAiData={askAiData} />} */}
      </ContainerWrapper>
      {/* {isAskAI && !hideResponseSection && <AskAIFooter  disabled={showTopRecommendation && searchCount >= 3} onSubmitFollowUp={callVzgptChat} isLoading={isChatLoading} resultsCount={courseResults?.length || 0}/>} */}
      {renderedIsAskAI && !hideResponseSection && <AskAIFooter  disabled={showTopRecommendation && searchCount >= 3} onSubmitFollowUp={callVzgptChat} isLoading={isChatLoading} resultsCount={courseResults?.length || 0}/>}
</div>
      <NewSearchModal
        showNewSearchModal={showNewSearchModal}
        setShowNewSearchModal={setShowNewSearchModal}
        handleNewSearchConfirm={handleNewSearchConfirm}
        askAiData={askAiData}
        triggerButtonRef={newSearchButtonRef}
      />
       <LangSwitchModal
        showLangSwitchModal={showLangSwitchModal}
        setShowLangSwitchModal={setShowLangSwitchModal}
        handleLangSwitchConfirm={handleLangSwitchConfirm}
        askAiData={askAiData}
      />
    </>
  );
};

export default AskAIPage;
